class StorageValidation {
  public static validateJson(data: string): boolean {
    try {
      JSON.parse(data);

      return true;
    } catch (error) {
      console.warn('Faster failed to parse storage data\n', data, '\n', error);

      return false;
    }
  }
}

export default StorageValidation;
